import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i1386639441__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Statistik / digital", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i1386639441__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M169.13 28H22.87C19.08 28 16 31.08 16 34.87v86.94c0 3.79 3.08 6.87 6.87 6.87h146.26c3.79 0 6.87-3.08 6.87-6.87V34.87c0-3.79-3.08-6.87-6.87-6.87m-93.97 77.37h-8V91.29h8zm16.56 0h-8V77.21h8zm16.56 0h-8V63.13h8zm16.56 0h-8V49.05h8z",
      style: {"fill":"none"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M169.13 20H22.87C14.67 20 8 26.67 8 34.87v86.94c0 8.2 6.67 14.87 14.87 14.87H92v13.74H65.43v8h61.13v-8H99.99v-13.74h69.13c8.2 0 14.87-6.67 14.87-14.87V34.87c0-8.2-6.67-14.87-14.87-14.87ZM176 121.81c0 3.79-3.08 6.87-6.87 6.87H22.87c-3.79 0-6.87-3.08-6.87-6.87V34.87c0-3.79 3.08-6.87 6.87-6.87h146.26c3.79 0 6.87 3.08 6.87 6.87z",
      class: "i1386639441__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M67.16 91.29h8v14.08h-8zM83.72 77.21h8v28.16h-8zM100.28 63.13h8v42.24h-8zM116.84 49.05h8v56.32h-8z",
      class: "i1386639441__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "report"}) } }